import apiClient from '../apiClient';
import { PUT_UPDATE_PROFILE_URL } from '../apiUrl';

const getUserProfile = (id, data) => {
  return apiClient.put(`${PUT_UPDATE_PROFILE_URL}/${id}`, data);
};

export default getUserProfile;
